
// Stage Base url
// export const BASE_URL = "https://ec2-3-110-218-121.ap-south-1.compute.amazonaws.com/";

// production. Base url
export const BASE_URL = "https://isbc-dev.com/";

// testing url for payment
// export const BASE_URL = "http://192.168.0.160:8000/";
